import $ from 'jquery';
import layout from '../Layout';
import fitvids from 'fitvids';
import ProductImages from './ProductImages';
import ProductForm from './ProductForm';
import CurrencyConverter from 'shopify-currency-converter';

export default class ProductDetails {
  constructor($el, section, inQuickshop) {
    this.data = section.data;
    this.onboarding = this.data.onboarding;
    this.postMessage = section.postMessage;
    this.inQuickshop = inQuickshop;
    this.type = section.type;

    this.$el = $el;
    this.$window = $(window);
    this.$productImages = $('[data-product-images]', $el);
    this.$productImageItems = $('[data-product-image]', $el);
    this.productImagesCount = this.$productImageItems.length;
    this.$productDetails = $('[data-product-details]', $el);
    this.$menu = $('[data-product-menu-container]', $el);
    this.$atc = $('[data-product-atc]', $el);

    this.positionDetails = this._positionDetails.bind(this);
    this._handleVariantChange = this._handleVariantChange.bind(this);

    // Alert
    this.$alert = $('.product-alert', $el);

    this.productImages = new ProductImages(this.$el[0], {
      images_layout: section.data.images_layout,
      thumbnails_direction: section.data.thumbnails_direction,
      navigateToImages: false,
    });

    this.listeningForVariantChange = false;
    this.listenForVariantChange();

    // Form
    if (!this.onboarding && this.data.form_is_inline) {
      this.form = new ProductForm(this.$el.find('[data-product-details]'), {
        form: $('[data-product-form-inline]', this.$el),
        product: this.data.product,
        moneyFormat: this.data.money_format,
        postMessage: section.postMessage,
        useHistory: this.data.use_history,
        enableCartRedirection: this.data.enable_cart_redirection,
        onAddToCart: () => this._onATC(),
        onSuccess: (response, quantity) => this._onAtcSuccess(response, quantity),
        onError: (response, error) => this._onAtcError(response, error),
      });

      if (this.type !== 'dynamic-product' && !this.inQuickshop) {
        $(window).trigger('product-variant-switch', { variant: this.form.variantHelper.getSelectedVariant() });
      }
    }

    // Handle layout changes
    this.onLayoutChange = () => this._layout();
    layout.onBreakpointChange(this.onLayoutChange);

    // Initial positioning
    this._layout();

    // Events
    this.events = [
      // Dismiss alert
      this.$alert
        .find('.product-alert-dismiss')
        .on('click.product', () => this._hideAlert()),
    ];

    fitvids();
  }

  selectImageByVariant(variant) {
    this.productImages.selectImageByVariant(variant);
  }

  listenForVariantChange() {
    if (!this.listeningForVariantChange) {
      $(window).on('product-variant-switch', this._handleVariantChange);
      this.listeningForVariantChange = true;
    }
  }

  stopListeningForVariantChange() {
    if (this.listeningForVariantChange) {
      $(window).off('product-variant-switch', this._handleVariantChange);
      this.listeningForVariantChange = false;
    }
  }

  unload() {
    this.$window.off('.product-details');
    layout.offBreakpointChange(this.onLayoutChange);
    this._hideAlert();

    if (this.form) this.form.unload();

    this.productImages.unload();
    this.stopListeningForVariantChange();
  }

  _layout() {
    if (layout.isBreakpoint('L')) {
      this.$window.on('resize.product-details', this.positionDetails);
    } else {
      this.$window.off('resize.product-details');
    }

    this._positionDetails();
  }

  _positionDetails() {
    if (this.inQuickshop) {
      this.productImages.setOptions({ navigateToImages: true });
      return;
    }

    let isSticky = false;

    if (layout.isBreakpoint('L')) {
      const imagesHeight = this.$productImages.outerHeight();
      const detailsHeight = this.$productDetails.outerHeight();
      const windowHeight = window.innerHeight;
      const menuHeight = this.$menu.outerHeight() || 0;
      const availableHeight = windowHeight - menuHeight;

      isSticky = (
        imagesHeight > availableHeight
        && detailsHeight < availableHeight
      );
    }

    this.productImages.setOptions({ navigateToImages: isSticky });
    this.$productDetails.toggleClass('product-details-sticky', isSticky);
  }

  _onATC() {
    this._hideAlert();
    this.$atc[0].classList.add('loading');
  }

  _onAtcSuccess() {
    this.$atc[0].classList.remove('loading');
    this.postMessage('header-minicart:set-open');
  }

  _onAtcError(response, error) {
    this.$atc[0].classList.remove('loading');
    this._showAlert(error, 'error');
  }

  _handleVariantChange(event, data) {
    this._onVariantChange(data);
  }

  _onVariantChange({ variant, firstLoad, isProduct }) {
    if (isProduct && !isProduct(this.data.product)) {
      return;
    }

    if (firstLoad) {
      if (this.type !== 'dynamic-product') {
        this.productImages.setOptions({ navigateToImages: true });
        this.productImages.selectImageByVariant(variant);
        this._positionDetails();
      }
    } else {
      this.productImages.selectImageByVariant(variant);
    }

    this.$el.find('.product-form-inline-atc-button')
      .prop('disabled', !variant.available)
      .find('[data-product-inline-atc-text]')
      .text(variant.available
        ? this.data.text.product_available
        : this.data.text.product_unavailable,
      );

    this.$productDetails.find('[data-variant-price]')
      .text(Shopify.formatMoney(variant.price, this.data.money_format))
      .each((index, el) => CurrencyConverter.update(el));
  }

  _showAlert(message, type = null) {
    this._hideAlert();

    // Add class name
    if (type) {
      this.alertClassName = `product-alert-${type}`;
      this.$alert.addClass(this.alertClassName);
    }

    // Set text
    const $message = this.$alert.find('.product-alert-message');
    $message.html(message);
    this.$alert.one('revealer-hide', event => $message.text(''));

    // Show
    this.$alert.revealer('show');

    // Positioning
    this._positionAlert();
    $(window).on('scroll.product-alert', event => this._positionAlert());
    this.alertTimeout = setTimeout(() => {
      this._hideAlert();
    }, 3000);
  }

  _hideAlert() {
    clearTimeout(this.alertTimeout);
    // Remove custom class names
    this.$alert.removeClass(this.alertClassName);
    this.alertClassName = null;

    // Stop positioning
    $(window).off('scroll.product-alert');

    // Hide
    this.$alert.revealer('hide');
  }

  _positionAlert() {
    if (this.inQuickshop) {
      return;
    }

    this.$alert[0].style.top = window.pageYOffset;
    this.$alert[0].classList.add('product-alert-fixed');
  }
}
